export default __webpack_public_path__ + "static/media/t-curriculum-blue.8e35a876.svg";